"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBlock = exports.duplicateBlock = exports.moveBlockDown = exports.moveBlockUp = void 0;
const slate_1 = require("slate");
const behavior_1 = require("../behavior");
const cloneBinary_1 = require("@jsonjoy.com/util/lib/json-clone/cloneBinary");
const moveBlockUp = (editor) => {
    const entry = (0, behavior_1.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [, path] = entry;
    if (!slate_1.Path.hasPrevious(path))
        return false;
    slate_1.Transforms.moveNodes(editor, { at: path, to: slate_1.Path.previous(path) });
    return true;
};
exports.moveBlockUp = moveBlockUp;
const moveBlockDown = (editor) => {
    const entry = (0, behavior_1.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [, path] = entry;
    const [parent] = slate_1.Editor.parent(editor, path);
    const lastIndex = path[path.length - 1];
    const siblingCount = parent.children?.length ?? 0;
    if (lastIndex >= siblingCount - 1)
        return false;
    slate_1.Transforms.moveNodes(editor, { at: path, to: slate_1.Path.next(path) });
    return true;
};
exports.moveBlockDown = moveBlockDown;
const duplicateBlock = (editor) => {
    const entry = (0, behavior_1.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [block, path] = entry;
    slate_1.Transforms.insertNodes(editor, (0, cloneBinary_1.cloneBinary)(block), { at: slate_1.Path.next(path) });
    return true;
};
exports.duplicateBlock = duplicateBlock;
const deleteBlock = (editor) => {
    const entry = (0, behavior_1.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [, path] = entry;
    slate_1.Transforms.removeNodes(editor, { at: path });
    return true;
};
exports.deleteBlock = deleteBlock;
